import { FaSortDown, FaSortUp } from "react-icons/fa"

import { Line } from "@/components/Line"
import { PriceMovementType } from "@/services/prices"
import { join } from "@/utils/join"

import { useTileContext } from "../TileContext"
import { useRfqPayload } from "../TileFooter/RfqTimer"
import { usePriceMovementData } from "./priceMovement.state"

export const PriceMovementInner = ({
  spread,
  movementType,
  showingChart,
}: {
  spread: string
  movementType?: PriceMovementType
  showingChart?: boolean
}) => {
  const paddingClass = showingChart ? "px-md" : "px-0"
  return (
    <div
      className={join(
        paddingClass,
        "relative flex w-full flex-col items-center justify-center grid-area-[movement]",
      )}
    >
      <Line height={showingChart ? "3xl" : "lg"} />
      <div
        className={join(
          movementType === PriceMovementType.UP ? "visible" : "hidden",
          "visible absolute top-6/12 -mt-4 text-success-primary",
        )}
        aria-hidden="true"
      >
        {<FaSortUp />}
      </div>
      <p className="py-lg text-sm-regular text-tertiary">{spread}</p>
      <div
        className={join(
          movementType === PriceMovementType.DOWN ? "visible" : "hidden",
          "absolute bottom-6/12 -mb-4 text-error-primary",
        )}
        aria-hidden="true"
      >
        {<FaSortDown />}
      </div>
      <Line height={showingChart ? "3xl" : "lg"} />
    </div>
  )
}

export const PriceMovement = () => {
  const payload = useRfqPayload()
  const { spread, movementType } = usePriceMovementData()
  const { showingChart } = useTileContext()
  return (
    <PriceMovementInner
      showingChart={showingChart}
      spread={payload?.rfqResponse.price.spread || spread}
      movementType={payload ? PriceMovementType.NONE : movementType}
    />
  )
}
